import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { Construction } from 'lucide-react';

export default function PlaceholderPage({ title, description, icon: Icon = Construction }) {
  return (
    <AdminLayout>
      <div className="p-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl p-12 text-center shadow-sm">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon className="w-10 h-10 text-gray-400" />
            </div>
            <h1 className="text-3xl font-bold text-navy mb-4">{title}</h1>
            <p className="text-gray-600 mb-8">{description}</p>
            <div className="inline-block px-6 py-3 bg-yellow-100 text-yellow-800 rounded-lg font-medium">
              Coming Soon
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
